export const FETCH_PROFORMACONSTRUCTION_BEGIN = "FETCH_PROFORMACONSTRUCTION_BEGIN";
export const FETCH_PROFORMALISTS_SUCCESS = "FETCH_PROFORMALISTS_SUCCESS";
export const FETCH_PROFORMADATE_SUCCESS = "FETCH_PROFORMADATE_SUCCESS";
export const FETCH_PROFORMAREBALANCEMETHOD_SUCCESS = "FETCH_PROFORMAREBALANCEMETHOD_SUCCESS";
export const FETCH_PROFORMABACKFILL_SUCCESS = "FETCH_PROFORMABACKFILL_SUCCESS";
export const FETCH_PROFORMATREELIST_SUCCESS = "FETCH_PROFORMATREELIST_SUCCESS";
export const FETCH_PROFORMAENTITIES_SUCCESS = "FETCH_PROFORMAENTITIES_SUCCESS";
export const FETCH_PROFORMACONSTRUCTION_FAILURE = "FETCH_PROFORMACONSTRUCTION_FAILURE";
